export enum OutputFormatterTypes {
  STEP = 'step',
  SUMMARY = 'summary',
  EMAIL = 'email',
}
